import { Illustration } from '@/components/HideIllustrationsExternal'
import { RenderIf } from '@/components/RenderIf'
import TimeZoneLuxon from '@/components/TimeZoneLuxon'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { Button, getTheme, Text } from '@conexasaude/conexa-hero'
import { Fragment, FunctionComponent, useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { LightHeader } from '../../components/LightHeader'
import { useStyles } from './styles'
import { ChangePasswordSuccessState } from './types'

const ChangePasswordSuccess: FunctionComponent = () => {
  const history = useHistory()
  const location = useLocation<ChangePasswordSuccessState>()
  const { clinic, user } = useAuthContext()
  const styles = useStyles()
  const theme = getTheme()
  if (!location.state?.passwordChanged) {
    history.push('/')
  }

  const goToHome = useCallback(() => {
    history.push('/')
  }, [history])

  return (
    <Fragment>
      <LightHeader uniqueCode={clinic.uniqueCode} redirectTo="/" />

      <div css={styles.container}>
        <div css={styles.changePasswordSuccess}></div>

        <div css={styles.successCard}>
          <Text
            color={theme.colors.feedback.success[300]}
            variant="headingLarge"
          >
            Nova senha criada!
          </Text>
          <Text color={theme.colors.neutral[500]} css={styles.subtitle}>
            Caso você tenha mais de uma conta associada ao mesmo e-mail, utilize
            a nova senha para acessar todas as suas contas.
          </Text>
          <Illustration name="positive" width="240px" height="240px" />
          <Button fullWidth onClick={goToHome}>
            Ok, entendi
          </Button>
        </div>

        <div css={styles.timeZoneSection}>
          <TimeZoneLuxon />
          <RenderIf condition={Boolean(user?.patientId)}>
            <Text>
              ID: {user?.patientId} | Clínica: {user?.clinic?.name}
            </Text>
          </RenderIf>
        </div>
      </div>
    </Fragment>
  )
}

export default ChangePasswordSuccess
